import React from 'react';
import { Col, Collapse, Row } from 'antd';
import { useTranslation } from 'react-i18next';

import './styles.less';

const { Panel } = Collapse;

const I18N_BASE_PATH =
  'pages.private.KYBCompany.pages.companyDetails.subPages.companyInfo.businessIdentity';

const HeaderPanel = ({ title }) => (
  <div className="header-panel">
    <strong>{title}</strong>
  </div>
);

const ElevatedRiskCardNonCollapse = ({ label, data }) => (
  <div className="elevated-risk-card">
    <span>{label}</span>
    <div className="card-non-collapse">
      <span>{data?.country}</span> <span>-</span>
      <span>{data?.score}</span>
    </div>
  </div>
);

const RiskFactorsCollapse = ({ title, businessIdentityData, collapseOpened = false }) => {
  const { t: translate } = useTranslation();

  const key = 'company-info-business-identity-risk-factors';

  const collapseKey = [key];
  const collapseProps = {
    activeKey: collapseKey,
    defaultActiveKey: collapseKey,
  };
  const props = collapseOpened ? collapseProps : {};

  return (
    <div className="wrapper-collapse-panel">
      <div className="top-infos">
        <strong>{title}</strong>
      </div>

      <Collapse
        expandIconPosition="left"
        ghost
        className="mrg-top-30 page-break-inside-avoid"
        {...props}
      >
        <Panel
          key={key}
          header={
            <HeaderPanel
              title={`${translate(
                `${I18N_BASE_PATH}.riskFactors.relevant.title`,
                'Relevant'
              )} (${businessIdentityData?.risks?.length ?? '0'})`}
            />
          }
        >
          <div className="wrapper-risk-factors-collapse">
            {businessIdentityData?.risks?.map((risk) => (
              <>
                <ElevatedRiskCardNonCollapse
                  data={{
                    country: risk?.countries?.[0],
                    score: risk?.value ?? '-',
                  }}
                  label={translate(
                    `${I18N_BASE_PATH}.riskFactors.relevant.api.risk.${risk.name}`,
                    risk.name
                  )}
                />
              </>
            ))}
          </div>
        </Panel>
      </Collapse>
    </div>
  );
};

const AttributesCard = ({ properties, key }) => {
  return (
    <div className="wrapper-collapse" key={key}>
      <Row className="panel-row-content">
        {Object.keys(properties || {})?.map((property) => {
          return (
            <Row className="wrapper-col-content">
              <Col span={10} className="column-description">
                <strong>
                  {property
                    .toLowerCase()
                    .replace(/_/g, ' ')
                    .replace('sayari', 'source')
                    .split(' ')
                    .map((s) => s.charAt(0).toUpperCase() + s.slice(1))
                    .join(' ')}
                </strong>
              </Col>
              <Col span={14} className="column-message">
                <span>
                  {properties[property]
                    ?.toString()
                    ?.toLowerCase()
                    ?.replace('sayari', 'Source')}
                </span>
              </Col>
            </Row>
          );
        })}
      </Row>
    </div>
  );
};

const AttributesCollapse = ({ title, businessIdentityData, collapseOpened }) => {
  const { t: translate } = useTranslation();

  const allKeys = businessIdentityData?.attributes?.map((attribute) => attribute?.name);
  const collapseProps = {
    activeKey: allKeys,
    defaultActiveKey: allKeys,
  };
  const props = collapseOpened ? collapseProps : {};

  return (
    <div className="wrapper-collapse-panel">
      <div className="top-infos">
        <strong>{title}</strong>
      </div>
      {businessIdentityData?.attributes?.map((attribute) => {
        const attributeName = attribute?.name;
        return (
          <>
            <Collapse ghost className="mrg-top-30 page-break-inside-avoid" {...props}>
              <Panel
                key={attributeName}
                header={
                  <HeaderPanel
                    title={`${translate(
                      `${I18N_BASE_PATH}.attributes.api.${attributeName}`,
                      attributeName
                    )} (${attribute?.total})`}
                  />
                }
              >
                <div className="wrapper-attributes-content">
                  {attribute?.data?.map((d, dIndex) => {
                    return (
                      <AttributesCard
                        properties={d?.properties}
                        // eslint-disable-next-line react/no-array-index-key
                        key={`${attribute.name}_${dIndex}`}
                      />
                    );
                  })}
                </div>
              </Panel>
            </Collapse>
            <div className="apply-border-bottom" />
          </>
        );
      })}
    </div>
  );
};

const WrapperCollapsePanel = ({
  businessIdentityData,
  collapseOpened,
  hideRiskFactors = false,
  hideAttributes = false,
}) => {
  const { t: translate } = useTranslation();

  return (
    <>
      {!hideRiskFactors && (
        <RiskFactorsCollapse
          title={translate(`${I18N_BASE_PATH}.riskFactors.title`, 'Risk Factors')}
          businessIdentityData={businessIdentityData}
          collapseOpened={collapseOpened}
        />
      )}
      {!hideAttributes && (
        <AttributesCollapse
          title={translate(`${I18N_BASE_PATH}.attributes.title`, 'Attributes')}
          businessIdentityData={businessIdentityData}
          collapseOpened={collapseOpened}
        />
      )}
    </>
  );
};

export default WrapperCollapsePanel;
